<!-- Template from page -->
<template>
  <section>
    <left-menu/>

    <modal-change-linkedin :user-obj="dataUser" :actionLinkedin.sync="linkedinEmit"/>
    <modal-change-whats :user-obj="dataUser" :actionWhats.sync="whatsEmit"/>

    <div id="mainContent" class="perfil-content">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">{{$t("Meu Perfil")}}</h1>
        </div>

        <loading-page v-if="loadingRequest" />

        <div v-else class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-30">
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="col-xs-12 col-sm-12 col-md-12 default-box box-perfil">
              <input type="file" id="documentFile1" ref="myFiles" class="custom-file-input" @change="previewFiles" style="display: none">
              <div class="user-photo">
                <div v-on:click="attachFile('#documentFile1')" class="hover-img"><img src="../../../..../../../assets/img/icons/camera-white.png" class="img-responsive" alt="camera"/></div>
                <img v-if="userInfo.photo" v-bind:src="userInfo.photo" class="img-responsive photo" alt="Usuário">
                <div v-else class="user-name-photo">
                  <span class="nunito">{{userInfo.name | formatName}}</span>
                </div>
              </div>

              <div class="user-info">
                <p class="nunito user-name">{{userInfo.name}}</p>
                <p class="nunito user-cod">{{$t("Código")}} #{{userInfo.code}}</p>
              </div>

              <button v-on:click="changePassword()" class="btn-change-password"><img src="../../../..../../../assets/img/icons/lock-white.png" class="img-responsive" alt="alterar senha" />{{$t("Alterar senha")}}</button>
              <button v-on:click="logout()" class="btn-exit">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path class="b" d="M17.069,3.01H2.927A1.932,1.932,0,0,0,1,4.937V8.781H2.927V4.918H17.069V18.434H2.927V14.561H1v3.863a1.916,1.916,0,0,0,1.927,1.908H17.069A1.916,1.916,0,0,0,19,18.424V4.937A1.926,1.926,0,0,0,17.069,3.01ZM10.634,15.524l3.854-3.854L10.634,7.817v2.89H1v1.927h9.634Z" transform="translate(2 0.49)"/>
                </svg>
                <span>{{$t("Sair")}}</span>
              </button>
            </div>
          </div>

          <div v-if="!failRequest" class="col-xs-12 col-sm-6 col-md-4">
            <div class="col-xs-12 col-sm-12 col-md-12 default-box box-personal-data">
              <p class="certa title">{{$t("Dados Pessoais")}}</p>

              <div class="content-info">
                <p class="nunito">{{$t("Email:")}} <span v-bind:title="userInfo.email">{{userInfo.email | limitTo(33)}}</span></p>
                <p class="nunito">{{$t("Função:")}} <span v-bind:title="dataUser.officeMe">{{dataUser.officeMe | limitTo(33)}}</span></p>
                <p class="nunito">{{$t("Turno:")}} <span v-bind:title="dataUser.workShiftTurn">{{dataUser.workShiftTurn | limitTo(33)}}</span></p>
              </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-12 default-box box-contact offset-top-30">
              <p class="certa title">{{$t("Contato")}}</p>

              <p class="nunito contact">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path class="b" d="M6.62,10.79a15.149,15.149,0,0,0,6.59,6.59l2.2-2.2a.994.994,0,0,1,1.02-.24,11.407,11.407,0,0,0,3.57.57,1,1,0,0,1,1,1V20a1,1,0,0,1-1,1A17,17,0,0,1,3,4,1,1,0,0,1,4,3H7.5a1,1,0,0,1,1,1,11.36,11.36,0,0,0,.57,3.57,1,1,0,0,1-.25,1.02Z"/>
                </svg>
                <span v-if="dataUser.phoneNumber">{{dataUser.phoneNumber}}</span>
                <span v-if="!dataUser.phoneNumber">-</span>
              </p>

              <p v-if="dataUser.cellPhoneNumber" class="nunito contact">
                <svg width="19.776" height="19.775" viewBox="0 0 19.776 19.775">
                  <path class="a" d="M11.888,2A9.887,9.887,0,0,0,3.274,16.741L2.016,21.229a.43.43,0,0,0,.414.546.443.443,0,0,0,.1-.012L7.217,20.6A9.888,9.888,0,1,0,11.888,2Zm4.974,13.377a2.614,2.614,0,0,1-1.714,1.192,3.529,3.529,0,0,1-1.6-.1,14.877,14.877,0,0,1-1.447-.528,11.267,11.267,0,0,1-4.336-3.785A4.844,4.844,0,0,1,6.729,9.564a2.8,2.8,0,0,1,.889-2.091.938.938,0,0,1,.677-.314c.169,0,.338,0,.487.009s.365-.059.571.43.719,1.736.782,1.861a.457.457,0,0,1,.021.439,1.69,1.69,0,0,1-.254.418c-.127.147-.267.327-.381.439s-.259.261-.111.512A7.554,7.554,0,0,0,10.822,13a6.959,6.959,0,0,0,2.041,1.244c.254.126.4.1.55-.063s.635-.732.8-.983.338-.209.571-.126,1.481.69,1.735.815.423.188.487.293A2.067,2.067,0,0,1,16.862,15.377Z" transform="translate(-2 -2)"/>
                </svg>
                <span>{{dataUser.cellPhoneNumber}}</span>
                <svg v-on:click="changeWhats()" width="24" height="24" viewBox="0 0 24 24" class="rr">
                  <path class="a" d="M3,17.25V21H6.75L17.81,9.94,14.06,6.19ZM20.71,7.04a1,1,0,0,0,0-1.41L18.37,3.29a1,1,0,0,0-1.41,0L15.13,5.12l3.75,3.75,1.83-1.83Z"/>
                </svg>
              </p>

              <button v-else v-on:click="changeWhats()" class="nunito whats-empty">
                <svg width="19.776" height="19.775" viewBox="0 0 19.776 19.775">
                  <path class="a" d="M11.888,2A9.887,9.887,0,0,0,3.274,16.741L2.016,21.229a.43.43,0,0,0,.414.546.443.443,0,0,0,.1-.012L7.217,20.6A9.888,9.888,0,1,0,11.888,2Zm4.974,13.377a2.614,2.614,0,0,1-1.714,1.192,3.529,3.529,0,0,1-1.6-.1,14.877,14.877,0,0,1-1.447-.528,11.267,11.267,0,0,1-4.336-3.785A4.844,4.844,0,0,1,6.729,9.564a2.8,2.8,0,0,1,.889-2.091.938.938,0,0,1,.677-.314c.169,0,.338,0,.487.009s.365-.059.571.43.719,1.736.782,1.861a.457.457,0,0,1,.021.439,1.69,1.69,0,0,1-.254.418c-.127.147-.267.327-.381.439s-.259.261-.111.512A7.554,7.554,0,0,0,10.822,13a6.959,6.959,0,0,0,2.041,1.244c.254.126.4.1.55-.063s.635-.732.8-.983.338-.209.571-.126,1.481.69,1.735.815.423.188.487.293A2.067,2.067,0,0,1,16.862,15.377Z" transform="translate(-2 -2)"/>
                </svg>
                <span>+ {{$t("Adicionar Whatsapp")}}</span>
              </button>
            </div>
          </div>

          <div v-if="!failRequest" class="col-xs-12 col-sm-12 col-md-4">
            <div class="col-xs-12 col-sm-6 col-md-12 default-box box-company-data">
              <p class="certa title">{{$t("Dados da Empresa")}}</p>
              <div class="content-info">
                <p class="nunito">{{$t("Nome:")}} <span v-bind:title="userInfo.company.name">{{userInfo.company.name}}</span></p>
                <p class="nunito">{{$t("Data de admissão:")}} <span v-bind:title="userInfo.admissionDate | formatDate">{{userInfo.admissionDate | formatDate}}</span></p>
                <p class="nunito">{{$t("Telefone:")}} <span v-bind:title="dataUser.phone">{{dataUser.phone}}</span></p>
              </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-12 default-box box-social offset-top-30">
              <div v-if="dataUser.linkedInUrl" class="content-linkedin">
                <img src="../../../..../../../assets/img/icons/linkedin-blue.png" class="img-responsive" alt="linkedin"/>
                <div class="content-link">
                  <p>
                    <a v-bind:href="dataUser.linkedInUrl" target="_blank" class="nunito">{{$t("Visualizar LinkedIn")}}</a>
                    <svg v-on:click="changeLinkedin()" width="24" height="24" viewBox="0 0 24 24" class="rr">
                      <path class="a" d="M3,17.25V21H6.75L17.81,9.94,14.06,6.19ZM20.71,7.04a1,1,0,0,0,0-1.41L18.37,3.29a1,1,0,0,0-1.41,0L15.13,5.12l3.75,3.75,1.83-1.83Z"/>
                    </svg>
                  </p>
                </div>
              </div>

              <div v-if="!dataUser.linkedInUrl" class="content-empty-linkedin">
                <img src="../../../..../../../assets/img/icons/linkedin-grey.png" class="img-responsive" alt="linkedin"/>
                <button v-on:click="changeLinkedin()" class="nunito">+ {{$t("Adicionar LinkedIn")}}</button>
              </div>
            </div>
          </div>

          <div v-if="failRequest" class="col-xs-12 col-sm-4 col-md-8 box-empty">
            <p class="nunito">{{$t("Tivemos um problema com a conexão. Tente novamente atualizando a página.")}}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<!-- Script from page -->
<script>
  import modalChangeWhats from "../../modals/perfilChangeWhats.vue";
  import modalChangeLinkedin from "../../modals/perfilChangeLinkedin.vue";
  import leftMenu from '../../components/leftMenu.vue'
  import vueFooter from "../../components/footer";
  import loadingPage from "../../components/loadingPage";

  import { ATT_USER_PHOTO, DATA_EMPLOYEE, UPLOAD_IMG } from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";
  import swal from "sweetalert";
  import moment from "moment";

  export default {
    name: 'perfil',
    components: {
      modalChangeLinkedin,
      modalChangeWhats,
      loadingPage,
      leftMenu,
      vueFooter
    },
    data() {
      return {
        linkedinEmit: '',
        whatsEmit: '',
        failRequest: false,
        loadingRequest: false,
        userInfo: {},
        dataUser: {}
      }
    },
    methods: {
      chnageUserPhoto(urlPhoto) {
        let obj = { id: this.dataUser.id, photo: urlPhoto };
        REQUEST_SERVICE.put(ATT_USER_PHOTO, obj).then((response) => {
          UTIL_SERVICE.console("RESULT ATT_USER_PHOTO:", response);

          let userInfo = UTIL_SERVICE.getStorage('userInfo');
          userInfo.photo = urlPhoto;
          UTIL_SERVICE.saveStorage('userInfo', userInfo);

          this.userInfo.photo = urlPhoto;
          this.userProfile = JSON.parse(window.localStorage.getItem('userProfile'));
          this.userProfile.photo = urlPhoto;

          UTIL_SERVICE.saveStorage('userProfile', {
            data: this.userProfile
          });
        }).catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal(this.$t("Aviso"), value.value, "error");
          });
        });
      },
      uploadDocument(file) {
        // this.uploadStage = "loading";
        // this.fileName = file.name;
        REQUEST_SERVICE.fileUpload(UPLOAD_IMG, file).then((response) => {
          UTIL_SERVICE.console("RESULT UPLOAD DOCUMENT: ", response);

          this.chnageUserPhoto(response.data);
          // this.uploadStage = "success";

        }).catch(reason => {
          // this.uploadStage = "fail";
        });
      },
      previewFiles() {
        this.files = this.$refs.myFiles.files;
        if (this.files.length) {
          if (this.files[0].size <= 2097152) {
            this.uploadDocument(this.files[0])
          } else {
            swal(this.$t("Aviso"), this.$t("Não foi possivel realizar o envio da imagem.\n\n Motivo: arquivo muito grande por favor enviar um arquivo menor que 2MB."), "warning");
          }
        }
      },
      attachFile(id) {
        $(id).click();
      },
      getUserDetail: function () {
        this.loadingRequest = true;
        this.failRequest = false;

        REQUEST_SERVICE.get(DATA_EMPLOYEE).then((response) => {
          UTIL_SERVICE.console("DATA_EMPLOYEE:", response.data);
          this.dataUser = response.data;

          UTIL_SERVICE.saveStorage('userProfile', {
            data: response.data
          });

          this.loadingRequest = false;
        }).catch(reason => {
          this.loadingRequest = false;
          this.failRequest = true;
        });
      },
      logout: function () {
        REQUEST_SERVICE.logout().then((response) => {
          window.localStorage.removeItem("dateLastPointConfirm");
          window.localStorage.removeItem("homeCtrl");
          window.localStorage.removeItem("configProgressPoint");
          window.localStorage.removeItem("solicitationCtrl");
          window.localStorage.removeItem("historyListPoints");
          window.localStorage.removeItem("darkMode");
          window.localStorage.removeItem("showFeelings");
          window.localStorage.removeItem("pointHistoryCtrl");
          window.localStorage.removeItem("myOccurrenceCtrl");
          window.localStorage.removeItem("myRequestsCtrl");
          window.localStorage.removeItem("mirrorCtrl");
          window.localStorage.removeItem("hourBalanceCtrl");
          window.localStorage.removeItem("3hours");
          window.localStorage.removeItem("dataConfirmPoint");
          window.localStorage.removeItem("userProfile");
          window.localStorage.removeItem("hourBalance");

          UTIL_SERVICE.setTheme();

          this.$router.push({path: '/login'});
        });
      },
      changePassword: function () {
        $("#modalChangePassword").modal();
      },
      changeLinkedin: function () {
        $("#perfilChangeLinkedin").modal();
      },
      changeWhats: function () {
        $("#perfilChangeWhats").modal();
      }
    },
    beforeMount(){
      this.userInfo = UTIL_SERVICE.getStorage('userInfo');

      try {
        this.userProfile = UTIL_SERVICE.getStorage('userProfile');
        if (!this.userProfile.data) {
          this.getUserDetail();
        } else {
          UTIL_SERVICE.console('GET DATA FROM STORAGE', this.userProfile);

          this.dataUser = this.userProfile.data;

          this.loadingRequest = false;
          this.failRequest = false;
        }
      } catch (e) {
        this.getUserDetail();
      }
    },
    watch: {
      linkedinEmit: function(response) {
        this.dataUser.linkedInUrl = response.value;

        this.userProfile = UTIL_SERVICE.getStorage('userProfile');
        this.userProfile.linkedInUrl = response.value;

        UTIL_SERVICE.saveStorage('userProfile', {
          data: this.userProfile
        });
      },
      whatsEmit: function(response) {
        this.dataUser.cellPhoneNumber = response.value;

        this.userProfile = UTIL_SERVICE.getStorage('userProfile');
        this.userProfile.cellPhoneNumber = response.value;
        UTIL_SERVICE.saveStorage('userProfile', {
          data: this.userProfile
        });
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/vue/views/restricted/perfil/Perfil.vue